export default __webpack_public_path__ + "static/media/iconProfile.b5e3bdd0.svg";